import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import { Autoplay, Pagination, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Using Killa room photos as placeholders for the slider
import slide1 from '../../assets/images/pages/murall.png';
import slide2 from '../../assets/images/killa/killa2.png';
import slide3 from '../../assets/images/pages/20.jpg';
import slide4 from '../../assets/images/killa/killa4.png';

const SliderOne = () => {

    const [datatext] = useState({
        subtitle: 'Tu escape perfecto empieza aquí',
        title: 'Bienvenidos a Rodex',
        desc: 'Contamos con habitaciones amplias, iluminadas y adaptadas para diferentes tipos de huéspedes.'
    });

    return (
        <section className="tf-section hero-slider" style={{ position: 'relative', padding: 0, height: '100vh', display: 'flex', alignItems: 'center' }}>
            {/* Background Slider */}
            <div style={{ position: 'absolute', top: '-180px', left: 0, width: '100%', height: 'calc(100% + 180px)', zIndex: 0 }}>
                <Swiper
                    modules={[Autoplay, Pagination, EffectFade]}
                    effect="fade"
                    spaceBetween={0}
                    slidesPerView={1}
                    loop
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 6000,
                        disableOnInteraction: false,
                    }}
                    style={{ width: '100%', height: '100%' }}
                >
                    <SwiperSlide>
                        <div style={{ backgroundImage: `url(${slide1})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '100%' }}>
                            <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', width: '100%', height: '100%' }}></div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div style={{ backgroundImage: `url(${slide2})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '100%' }}>
                            <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', width: '100%', height: '100%' }}></div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div style={{ backgroundImage: `url(${slide3})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '100%' }}>
                            <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', width: '100%', height: '100%' }}></div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div style={{ backgroundImage: `url(${slide4})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '100%' }}>
                            <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', width: '100%', height: '100%' }}></div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>

            {/* Content Overlay */}
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="block-text" style={{ paddingBottom: '80px' }} >
                            <h6 className="sub-title mb-6" data-aos="fade-up" style={{ color: '#fff' }}>{datatext.subtitle}</h6>
                            <h2 className="title mb-26" data-aos="fade-up" style={{ color: '#fff' }}>{datatext.title}</h2>
                            <p className="desc mb-43" data-aos="fade-up" style={{ color: '#eee', maxWidth: '600px', margin: '0 auto' }}>{datatext.desc}</p>
                            <div className="mt-4">
                                <Link to="/habitaciones" className="btn-action style-2" data-aos="fade-up" data-aos-duration="1200" >
                                    Ver Habitaciones
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default SliderOne;